



























import { computed, defineComponent, onMounted, ref, watch } from '@vue/composition-api';
import { Address } from '@/store/types';
import { isNotEmpty } from '@/utils/rules';

export default defineComponent({
	props: {
		value: {
			type: Object as () => Address,
		},
	},
	setup(props, { emit }) {
		const streetAddress = ref<string>('');
		const addressLocality = ref<string>('');
		const addressRegion = ref<string>('');
		const addressCountry = ref<string>('');
		const postalCode = ref<string>('');

		const address = computed<Address>(() => ({
			streetAddress: streetAddress.value,
			addressLocality: addressLocality.value,
			addressRegion: addressRegion.value,
			addressCountry: addressCountry.value,
			postalCode: postalCode.value,
		}));

		const assignValues = (address?: Address) => {
			streetAddress.value = address?.streetAddress ?? '';
			addressLocality.value = address?.addressLocality ?? '';
			addressRegion.value = address?.addressRegion ?? '';
			addressCountry.value = address?.addressCountry ?? '';
			postalCode.value = address?.postalCode ?? '';
		};

		onMounted(() => {
			assignValues(props.value);
		});

		watch(
			() => props.value,
			(address) => assignValues(address)
		);

		watch(
			() => address.value,
			(address) => emit('input', address)
		);

		return {
			streetAddress,
			addressLocality,
			addressRegion,
			addressCountry,
			postalCode,
			isNotEmpty,
		};
	},
});
